export enum EnumEnvironments {
	DEVELOPMENT = 'dev',
	LOCAL = 'local',
	PRODUCTION = 'prod',
	STAGING = 'staging',
	JEST = 'test',
}

export enum EnumNodeEnv {
	DEVELOPMENT = 'development',
	PRODUCTION = 'production',
	TEST = 'test',
}
